
//React
import React, { useEffect, useRef, useState } from 'react'
import { flushSync } from 'react-dom'
import { useTranslation } from "react-i18next"

//App
import { Alert, Spiner, TextAreaForm } from "../../components"
import { FamlaServices } from '../../services';
import { useAppSelector } from '../../stores';
import { BASE_URL_AUDIO } from '../../services';
import { Images } from '../../constants';
import { getTenantInitial, getTenantName } from '../../utils/brandingStyles';

import Area from "./area"
import ContentQuestion from "./contentQuestion"
import Question from "./question"
import { ButtonGroup } from '../../components';
import { iAlert } from '../../interfaces';
import FileUpload from './FileUpload'
import SuggestedProcessesCard from '../campaigns/components/SuggestedProcessesCard'
import { SuggestedProcess } from '../campaigns/types'
import TypingIndicator from '../../components/Analyse/TypingIndicator';
import MappingProgressChecklist from "./MappingProgressChecklist";
import VoiceRealtimeBar, { type VoiceRealtimeBarHandle } from "./VoiceRealtimeBar";
import Routes from '../../routes/Routes';
import { getProcessCreatePath } from '../../utils/processCreateRoute';
import { formatInterviewScrollHeader } from '../../utils/formatDate';
import { trackUiButtonEventAsync, UI_BUTTON_EVENTS } from '../../services/api/uiButtonStatsService';
import { isMappingDiscoveryComplete } from '../../utils/mappingGenerationStatus';
import OutlookPromoModal from '../../components/OutlookPromoModal';

//Interface
import { iInterview, iInterviewContent, iUser, typeProcess } from '../../components/type'
import {
    buildCollaboratorChecklistItems,
    buildOwnerChecklistItems,
    getGlobalProgress,
    getEffectiveCollaboratorMaxStepFromAnswers,
    getMaxStepFromAnswers,
    getMaxStepFromAnswersForInterview,
    type Step,
} from "../../features/process/progress/processMappingProgress";
import { extractMentionedRolesFromAnswers, resolveInviteRoleFromAnswer } from '../../utils/inviteRoleOptions';
import {
    getMapBuildAutoRefreshStorageKey,
    getMapBuildWaitRemainingSeconds,
    hasMapBuildAutoRefreshDone,
    isWaitingForDocumentMapBuild as checkWaitingForDocumentMapBuild,
    markMapBuildAutoRefreshDone,
    MAP_BUILD_WAIT_MESSAGE_REGEX,
} from "../../utils/mapBuildWait";

const END_INTERVIEW_REGEX = /^(End of the interview|Fin de l['']entretien|Fin de l['']interview)/i;

interface StateType {
    questionAndResponse: iInterviewContent[];
    interviewId: string;
    answer: string;
    isLoading: boolean
    processTitle: string
    email: string,
    isSubmit: boolean,
    role: string,
    isLoadingProcess: boolean,
    autorisation: boolean,

}

interface chilprops {
    time: number
    interviewwId: string | undefined
    id: string | undefined
    setInvited: (invited: string | undefined) => void
    swimlanes: Array<any>
    collaborator: iUser
    procesId: string
    interviews: iInterview
    processType: typeProcess
    isProcessTypeResolved?: boolean
    collaborationInterviews?: iInterview[]
    useModernLayout?: boolean
    canInviteCollaborators?: boolean
    /** Recharge les rôles/interviews du process (ex. après delete-from-here) pour la checklist + sidebar */
    onProcessMembersRefresh?: () => void | Promise<void>
    /** Remonte le décompte d'attente carto document vers la sidebar Diagrams */
    onMapBuildCountdownChange?: (seconds: number | null) => void
    /** Remonte le step courant de l'interview owner (ex. pour afficher « Ajouter contributeur » seulement en 1.5) */
    onOwnerStepChange?: (step: Step | null) => void
    /** Rôles métier détectés dans le fil (invited + questions 1.5) pour le modal d'invitation */
    onInviteRolesChange?: (roles: string[]) => void
    /**
     * Rempli par ChatBot : envoie le « Oui » d'invitation différé après succès du modal.
     * Sans ça, envoyer Oui tout de suite ferait avancer vers le rôle suivant pendant que le modal est ouvert.
     */
    inviteYesSenderRef?: React.MutableRefObject<(() => Promise<void>) | null>
}


const ChatBot = (props: chilprops) => {
    const {
        time,
        interviewwId,
        id,
        setInvited,
        swimlanes,
        collaborator,
        procesId,
        interviews,
        processType,
        isProcessTypeResolved = false,
        collaborationInterviews,
        useModernLayout = false,
        canInviteCollaborators = false,
        onProcessMembersRefresh,
        onMapBuildCountdownChange,
        onOwnerStepChange,
        onInviteRolesChange,
        inviteYesSenderRef,
    } = props
    const { t } = useTranslation()
    const refchat = useRef<HTMLDivElement>(null)
    const voiceRealtimeBarRef = useRef<VoiceRealtimeBarHandle | null>(null)
    const [stickyDateLabel, setStickyDateLabel] = React.useState<string>('')
    const [idLastAnwser, setIdLastAnwser] = React.useState("")
    const [isInputBlocked, setIsInputBlocked] = useState(false);
    const isWhatsAppChannel = (interviews as iInterview)?.channel === 'whatsapp';
    const users = useAppSelector((state) => state.auth);
    const [spinner, setSpinner] = React.useState(false)
    const [currentIndex, setCurrentIndex] = React.useState<number>(0);
    const [endOfInterview, setendOfInterview] = React.useState<boolean>(false);
    const [mapBuildCountdown, setMapBuildCountdown] = React.useState<number | null>(null);
    const mapBuildAutoRefreshTriggeredRef = useRef(false);
    const role = useAppSelector(state => state.role.role)
    const isAdminRole = role === "ADMIN" || role === "admin";
    const [file, setFile] = useState<File | null>(null);
    const [isFileUploading, setIsFileUploading] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isAudioFinished, setIsAudioFinished] = useState(false);
    const audioRef = useRef<HTMLAudioElement | null>(null);
    const [ownerStep, setOwnerStep] = useState<Step | null>(null);
    const [collabStepsById, setCollabStepsById] = useState<Record<string, Step | null>>({});
    const [isProgressLoading, setIsProgressLoading] = useState(false);
    const [voiceSessionActive, setVoiceSessionActive] = useState(false);

    // Déterminer si on est en mode campagne (avant l'initialisation de state)
    const isCampaignMode = !interviewwId && !procesId;
    const isLayoutReady = isCampaignMode || isProcessTypeResolved;
    const shouldShowMappingChecklist = isLayoutReady && !isCampaignMode && processType === "AI";
    
    // État pour les processus suggérés (mode campagne)
    const [suggestedProcesses, setSuggestedProcesses] = useState<SuggestedProcess[]>([]);
    
    // Initialiser isLoading à false si pas d'interviewwId (cas de la page campaigns)
    const [state, setState] = React.useState<StateType>({
        questionAndResponse: [],
        interviewId: "",
        answer: "",
        isLoading: interviewwId ? true : false,
        processTitle: "",
        email: "",
        isSubmit: false,
        role: "",
        isLoadingProcess: !isCampaignMode, // Pas besoin de charger un processus en mode campagne
        autorisation: true,
    })

    const [thumbs, setThumbs] = useState({
        up: false,
        down: false,
        comment: "",
        submit: false,
    })

    const [alert, setAlert] = useState<iAlert>({
        isActive: false,
        type: "",
        message: ""
    })
    
    const lastQuestion = state.questionAndResponse[state.questionAndResponse.length - 1];
    const lastAnsweredIndex = React.useMemo(() => {
        let last = -1;
        state.questionAndResponse.forEach((q, i) => {
            if (q?.content) last = i;
        });
        return last;
    }, [state.questionAndResponse]);
    const currentStep = React.useMemo(() => getMaxStepFromAnswers(state.questionAndResponse), [state.questionAndResponse]);

    const discoveryCompleted = isMappingDiscoveryComplete(swimlanes);

    const isWaitingForDocumentMapBuild = React.useMemo(
        () => checkWaitingForDocumentMapBuild(state.questionAndResponse),
        [state.questionAndResponse],
    );

    const invitedCollaborations = React.useMemo(() => {
        if (!collaborationInterviews) return [];
        return collaborationInterviews.filter((i) => !i.for_owner);
    }, [collaborationInterviews]);

    const isProcessOwner = React.useMemo(() => {
        if (isAdminRole) return true;
        const myId = users.user?._id ? String(users.user._id) : "";
        if (!myId) return false;
        if (!collaborationInterviews) return false;
        return collaborationInterviews.some((i) => i.for_owner && String(i.collaboration?.user?._id ?? "") === myId);
    }, [isAdminRole, users.user?._id, collaborationInterviews]);

    const interviewRecord = React.useMemo(() => {
        const raw: any = interviews as any;
        if (Array.isArray(raw)) return raw[0] ?? null;
        return raw ?? null;
    }, [interviews]);

    const isDocumentBasedMapFlow = React.useMemo(
        () => Boolean(interviewRecord?.file_in) || processType === "HUMAN" || processType === "IMAGE",
        [interviewRecord?.file_in, processType],
    );

    // Checklist should follow the displayed interview (owner vs collaborator), not the viewer.
    // When a process owner is viewing a collaborator interview, we still want collaborator checklist.
    const isOwnerInterview = React.useMemo(() => {
        // Prefer deriving from the actual answers being displayed.
        // Owner setup questions are phase 1.x, collaborator interviews are phase 2.x.
        if (currentStep && currentStep[0] === 2) return false;
        if (currentStep && currentStep[0] === 1) return true;
        if (interviewRecord && typeof interviewRecord === "object" && "for_owner" in interviewRecord) {
            return Boolean((interviewRecord as any).for_owner);
        }
        // If no currentStep yet and no explicit for_owner flag, check if logged-in user is process owner
        // If user is NOT process owner, default to collaborator checklist
        return isProcessOwner;
    }, [currentStep, interviewRecord, isProcessOwner]);

    // More explicit check: if user is definitely NOT a process owner, show collaborator checklist
    const shouldShowCollaboratorChecklist = React.useMemo(() => {
        // If we determined it's an owner interview, don't override
        if (isOwnerInterview) return false;
        // If user is explicitly not a process owner, show collaborator checklist
        if (!isProcessOwner) return true;
        // Default to whatever isOwnerInterview determined
        return !isOwnerInterview;
    }, [isOwnerInterview, isProcessOwner]);

    const collaboratorsForProgress = React.useMemo(() => {
        return invitedCollaborations.map((i) => {
            const rawId = i._id ?? null;
            const id = rawId ? String(rawId) : `pending:${i.collaboration?.user?.email ?? "unknown"}`;
            const step = rawId ? collabStepsById[String(rawId)] ?? null : null;
            return { id, step };
        });
    }, [invitedCollaborations, collabStepsById]);

    const effectiveOwnerStep = React.useMemo(() => {
        if (ownerStep) return ownerStep;
        if (currentStep && currentStep[0] === 1) return currentStep;
        return null;
    }, [ownerStep, currentStep]);

    React.useEffect(() => {
        // Priorité au step live du fil owner (passage immédiat en 1.5), sinon step pollé
        if (isOwnerInterview && currentStep && currentStep[0] === 1) {
            onOwnerStepChange?.(currentStep);
            return;
        }
        onOwnerStepChange?.(effectiveOwnerStep);
    }, [isOwnerInterview, currentStep, effectiveOwnerStep, onOwnerStepChange]);

    React.useEffect(() => {
        onInviteRolesChange?.(extractMentionedRolesFromAnswers(state.questionAndResponse));
    }, [state.questionAndResponse, onInviteRolesChange]);

    React.useEffect(() => {
        if (isWhatsAppChannel) {
            setIsInputBlocked(true);
        }
    }, [isWhatsAppChannel]);

    // Dans le fil owner agrégé, la question (1,5) peut ne pas être la dernière ligne visible.
    const ownerInviteOneFiveActionIndex = React.useMemo(() => {
        if (!interviewwId) return -1;
        const ownerId = String(interviewwId);
        const arr = state.questionAndResponse;
        for (let i = arr.length - 1; i >= 0; i--) {
            const q = arr[i];
            if (!q?.step || q.step.length < 2) continue;
            if (q.step[0] === 1 && q.step[1] === 5 && String(q.interview_id) === ownerId) {
                if (!String(q.content ?? "").trim()) return i;
            }
        }
        return -1;
    }, [interviewwId, state.questionAndResponse]);

    /** Oui cliqué : modal ouvert sur ce rôle — ne pas avancer le fil ni resynchroniser `invited` tant que le modal est ouvert. */
    const freezeInviteRoleRef = React.useRef(false);
    const pendingInviteYesRef = React.useRef<{
        interviewId: string | undefined;
        answerId: string;
    } | null>(null);
    const [inviteModalGate, setInviteModalGate] = React.useState(0);

    // Préremplir le modal avec le rôle de la question d'invitation courante (pas un rôle refusé plus tôt)
    React.useEffect(() => {
        if (freezeInviteRoleRef.current) return;
        if (ownerInviteOneFiveActionIndex < 0) return;
        const q = state.questionAndResponse[ownerInviteOneFiveActionIndex];
        const role = resolveInviteRoleFromAnswer(q);
        if (role) setInvited(role);
    }, [ownerInviteOneFiveActionIndex, state.questionAndResponse, setInvited, inviteModalGate]);

    // Annulation / fermeture du modal : dégeler le rôle ; si Oui n'a pas été confirmé par une invite, rester sur la même question.
    React.useEffect(() => {
        const el = document.getElementById('inviteUser');
        if (!el) return;
        const onHidden = () => {
            const cancelledPending = pendingInviteYesRef.current != null;
            if (cancelledPending) {
                pendingInviteYesRef.current = null;
            }
            freezeInviteRoleRef.current = false;
            setInviteModalGate((n) => n + 1);
        };
        el.addEventListener('hidden.bs.modal', onHidden);
        return () => el.removeEventListener('hidden.bs.modal', onHidden);
    }, []);

    const checklistItems = React.useMemo(() => {
        if (!shouldShowMappingChecklist) return [];
        if (isOwnerInterview && !shouldShowCollaboratorChecklist) {
            return buildOwnerChecklistItems({
                ownerStep: effectiveOwnerStep,
                collaborators: collaboratorsForProgress,
                discoveryCompleted,
                t,
            });
        }
        return buildCollaboratorChecklistItems(currentStep, t);
    }, [shouldShowMappingChecklist, isOwnerInterview, shouldShowCollaboratorChecklist, effectiveOwnerStep, collaboratorsForProgress, discoveryCompleted, currentStep, t]);

    const ownerProgressPercent = React.useMemo(() => {
        if (!shouldShowMappingChecklist || !isOwnerInterview || shouldShowCollaboratorChecklist) return undefined;
        return getGlobalProgress({ ownerStep: effectiveOwnerStep, collaborators: collaboratorsForProgress, discoveryCompleted });
    }, [shouldShowMappingChecklist, isOwnerInterview, shouldShowCollaboratorChecklist, effectiveOwnerStep, collaboratorsForProgress, discoveryCompleted]);

    const endReply = t('views.processInterview.reply1')
    const endReply0 = t('views.processInterview.reply2')
    const other = t('views.processInterview.reply3')
    const referenceQuestion = t('views.processInterview.reply4')
    const referenceQuestion1 = t('views.processInterview.reply5')

    
    const getMyInterviewByProcess = async () => {
        setState((prev) => ({ ...prev, isLoading: true }))
        try {
            let newData = await FamlaServices("api_host", `/answer/${interviewwId}`, "GET", "", users.access_token);
            if (newData.status === 200) {
                const responseData = newData.body.data;
                const dataQuestionAndResponse = responseData?.answers ?? responseData;

                setIsInputBlocked(!!responseData?.completed_at);

                const reverveData = dataQuestionAndResponse.reverse()
                // Réinitialiser complètement l'état quand on change de processus
                setState((prev) => ({ 
                    ...prev, 
                    questionAndResponse: reverveData, 
                    isLoading: false,
                    answer: "", // Réinitialiser la réponse en cours
                    isSubmit: false
                }))
            } else {
                setState((prev) => ({ ...prev, isLoading: false }))
            }
        } catch (error) {
            setState((prev) => ({ ...prev, isLoading: false }))
        }
    }

    /** Sans rechargement page: liste process + fil de discussion alignés sur l'API (delete-from-here). */
    const refreshAfterMessageDelete = async () => {
        if (onProcessMembersRefresh) {
            await onProcessMembersRefresh();
        }
        await getMyInterviewByProcess();
    }

    const getAutorisationOfUser = async () => {
        try {
            let data = await FamlaServices("api_host", `/interview/${interviewwId}`, "GET", "", users.access_token);
            if (data.status === 200) {
                setState((prev) => ({ ...prev, autorisation: data.body.data }))
            }
        } catch (error) {
            // Erreur silencieuse
        }
    }

    React.useEffect(() => {
        // Ne pas faire de requête si interviewwId est undefined (cas de la page campaigns)
        if (interviewwId) {
            // Réinitialiser l'état avant de charger les nouvelles données
            setState((prev) => ({ 
                ...prev, 
                questionAndResponse: [], 
                isLoading: true,
                answer: "",
                isSubmit: false
            }))
            getMyInterviewByProcess()
            getAutorisationOfUser();
        } else {
            // Si pas d'interviewwId, ne pas afficher le spinner
            setState((prev) => ({ ...prev, isLoading: false }))
        }

    }, [interviewwId, users.access_token]) // Retirer id et autres dépendances inutiles, se concentrer sur interviewwId

    React.useEffect(() => {
        if (!interviewwId || isCampaignMode) {
            mapBuildAutoRefreshTriggeredRef.current = false;
            setMapBuildCountdown(null);
            setendOfInterview(false);
            return;
        }

        if (!isDocumentBasedMapFlow || !isWaitingForDocumentMapBuild) {
            mapBuildAutoRefreshTriggeredRef.current = false;
            setMapBuildCountdown(null);
            setendOfInterview(false);
            return;
        }

        setendOfInterview(true);

        const completedAt = interviewRecord?.completed_at ?? null;
        const refreshStorageKey = getMapBuildAutoRefreshStorageKey(
            interviewwId,
            state.questionAndResponse,
            completedAt,
        );

        const tick = () => {
            const remaining = getMapBuildWaitRemainingSeconds(
                state.questionAndResponse,
                completedAt,
            );
            if (remaining === null) {
                setMapBuildCountdown(null);
                return;
            }
            if (remaining <= 0) {
                setMapBuildCountdown(0);
                if (refreshStorageKey && hasMapBuildAutoRefreshDone(refreshStorageKey)) {
                    return;
                }
                if (mapBuildAutoRefreshTriggeredRef.current) {
                    return;
                }
                mapBuildAutoRefreshTriggeredRef.current = true;
                if (refreshStorageKey) {
                    markMapBuildAutoRefreshDone(refreshStorageKey);
                }
                window.location.reload();
                return;
            }
            setMapBuildCountdown(remaining);
        };

        tick();
        const intervalId = window.setInterval(tick, 1000);
        return () => window.clearInterval(intervalId);
    }, [
        interviewwId,
        isCampaignMode,
        isDocumentBasedMapFlow,
        isWaitingForDocumentMapBuild,
        state.questionAndResponse,
        interviewRecord?.completed_at,
    ]);

    React.useEffect(() => {
        onMapBuildCountdownChange?.(mapBuildCountdown);
    }, [mapBuildCountdown, onMapBuildCountdownChange]);

    React.useEffect(() => {
        // if (
        //     state.questionAndResponse.length > 0 &&
        //     currentIndex === state.questionAndResponse.length - 1
        // ) {
        //     const currentAnswer = state.questionAndResponse[currentIndex];
        //     if (currentAnswer && currentAnswer._id !== lastReadAnswerId) {
        //         handleSynthesize(currentAnswer._id);
        //         setLastReadAnswerId(currentAnswer._id);
        //     }
        // }

        if (audioRef.current) {
            audioRef.current.currentTime = 0;
            audioRef.current = null
        }

    }, [state.questionAndResponse.length, currentIndex, interviewwId])

    React.useEffect(() => {
        // ModernInterviewView gère déjà le polling checklist — évite les appels dupliqués.
        if (useModernLayout) return;
        // Même logique que ModernInterviewView : alimenter collabStepsById pour tous les rôles
        // (owner + collaborateurs) afin que la progression / agrégats restent cohérents.
        if (!shouldShowMappingChecklist) return;
        if (!users.access_token) return;
        if (!procesId) return;

        let cancelled = false;
        let intervalId: number | undefined;

        const fetchMaxStepForInterview = async (
            interviewId: string,
            mode: "owner" | "collaborator"
        ): Promise<Step | null> => {
            try {
                const data = await FamlaServices("api_host", `/answer/${interviewId}`, "GET", "", users.access_token);
                if (data?.status !== 200) return null;
                const responseData = data.body?.data;
                const answers = responseData?.answers ?? responseData;
                const arr = Array.isArray(answers) ? answers : [];
                if (mode === "owner") {
                    return getMaxStepFromAnswersForInterview(arr, interviewId);
                }
                return getEffectiveCollaboratorMaxStepFromAnswers(arr);
            } catch (e) {
                return null;
            }
        };

        const resolveOwnerInterviewId = async (): Promise<string | undefined> => {
            try {
                const data = await FamlaServices("api_host", `/interview/process/${procesId}/owner`, "GET", "", users.access_token);
                if (data?.status !== 200) return undefined;
                const bodyData = data.body?.data;
                const interviewData = Array.isArray(bodyData) ? bodyData?.[0] : bodyData;
                const id = interviewData?._id;
                return id ? String(id) : undefined;
            } catch (e) {
                return undefined;
            }
        };

        const fetchSnapshot = async () => {
            if (cancelled) return;
            setIsProgressLoading(true);

            const collaboratorIds = Array.from(
                new Set(
                    invitedCollaborations
                        .map((i) => (i._id ? String(i._id) : null))
                        .filter((x): x is string => Boolean(x))
                )
            );

            const ownerInterviewId = await resolveOwnerInterviewId();

            const [ownerStepFromApi, collaboratorSteps] = await Promise.all([
                ownerInterviewId ? fetchMaxStepForInterview(ownerInterviewId, "owner") : Promise.resolve(null),
                Promise.all(
                    collaboratorIds.map(async (cid) => ({
                        id: cid,
                        step: await fetchMaxStepForInterview(cid, "collaborator"),
                    }))
                ),
            ]);

            if (cancelled) return;

            // Toujours refléter l’API (une troncature baisse le max step; maxStep(prev, api) bloquait la mise à jour)
            setOwnerStep(ownerStepFromApi);
            setCollabStepsById(() => {
                const next: Record<string, Step | null> = {};
                for (const c of collaboratorSteps) {
                    next[c.id] = c.step;
                }
                return next;
            });

            setIsProgressLoading(false);
        };

        fetchSnapshot();
        intervalId = window.setInterval(fetchSnapshot, 8000);

        return () => {
            cancelled = true;
            if (intervalId) window.clearInterval(intervalId);
        };
    }, [useModernLayout, shouldShowMappingChecklist, users.access_token, procesId, invitedCollaborations]);

    React.useEffect(() => {
        if (lastQuestion && lastQuestion.thumbs) {
            // thumbs est de type string | null, donc on vérifie s'il contient "up"
            try {
                const thumbsData = typeof lastQuestion.thumbs === 'string' 
                    ? JSON.parse(lastQuestion.thumbs) 
                    : lastQuestion.thumbs;
                setThumbs({
                    up: thumbsData?.up === true || false,
                    down: false,
                    comment: "",
                    submit: false,
                });
            } catch (e) {
                // Si ce n'est pas du JSON valide, on considère que c'est juste une string
                setThumbs({
                    up: lastQuestion.thumbs === 'up' || false,
                    down: false,
                    comment: "",
                    submit: false,
                });
            }
        }
    }, [lastQuestion]);

    React.useEffect(() => {
        if (refchat.current) {
            refchat.current.scrollTop = refchat.current.scrollHeight;
        }
        if (state.questionAndResponse?.length > 0) {
            setIdLastAnwser(state.questionAndResponse[state.questionAndResponse.length - 1]?._id);
        }

        const endInterviewRegex = END_INTERVIEW_REGEX;
        let shouldBlockInput = false;
        state.questionAndResponse.forEach((question, index) => {
            if (
                (
                    (question.step[0] === 1 && question.step[1] === 4 && question.question_text !== referenceQuestion) ||
                    (question.step[0] === 3 && question.step[1] === 5 && question.question_text !== referenceQuestion) ||
                    question.question_text === referenceQuestion1
                ) && index === state.questionAndResponse.length - 1
            ) {
                shouldBlockInput = true;
            } else if (
                (question.step[0] === 1 && question.step[1] === 3 && index === state.questionAndResponse.length - 1) ||
                (question.step[0] === 1 && question.step[1] === 5 && index === ownerInviteOneFiveActionIndex)

            ) {
                shouldBlockInput = true;
            }

            if (
                (processType === "HUMAN" &&
                    (question.step[0] === 4 && question.step[1] === 5 && index === state.questionAndResponse.length - 1) ||
                    (question.step[0] === 4 && question.step[1] === 3 && index === state.questionAndResponse.length - 1) ||
                    (question.step[0] === 4 && question.step[1] === 8 && index === state.questionAndResponse.length - 1)
                )
            ) {
                shouldBlockInput = true;
            }

            if (
                processType === "IMAGE"
                 &&
                question.step[0] === 5 &&
                // question.step[1] === 1 &&
                question.step[1] === 8 &&

                index === state.questionAndResponse.length - 1
            ) {
                // Pour les processus de type "IMAGE", l'input doit être désactivé à l'étape [5,1]
                // uniquement si cette question est la dernière du tableau (position finale de l'interview)
                shouldBlockInput = true;
            }

            if (index === state.questionAndResponse.length - 1 && endInterviewRegex.test(question.question_text)) {
                shouldBlockInput = true;
            }



            // [STEP REFRESH UX] Le step (1, 8) signale un rafraîchissement (fin d'interview, etc.)
            // Pour les flux document (HUMAN/IMAGE/file_in), le refresh est différé de 10 min.
            if (question.step[0] === 1 && question.step[1] === 8 && index === state.questionAndResponse.length - 1) {
                if (!isDocumentBasedMapFlow && !MAP_BUILD_WAIT_MESSAGE_REGEX.test(question.question_text ?? '')) {
                    window.location.reload();
                }
            }

        });

        setIsInputBlocked(shouldBlockInput);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.questionAndResponse, state.answer, id, spinner, currentIndex, thumbs.down, alert.isActive, file, ownerInviteOneFiveActionIndex, isDocumentBasedMapFlow]);



    // Fonction pour analyser l'objectif et suggérer des processus (mode campagne)
    const analyzeObjectiveAndSuggestProcesses = async (objective: string): Promise<SuggestedProcess[]> => {
        try {
            // TODO: Remplacer par l'endpoint réel quand il sera disponible
            // Pour l'instant, simulation avec des processus suggérés
            // const endpoint = `/campaign/analyze-objective`;
            // const payload = { objective };
            // const data = await FamlaServices("api_host", endpoint, "POST", payload, users.access_token);
            // return data.body.data.suggestedProcesses;
            
            // Simulation temporaire
            await new Promise(resolve => setTimeout(resolve, 1500)); // Simuler un délai
            
            // Retourner des processus suggérés basés sur l'objectif
            const lowerObjective = objective.toLowerCase();
            const suggested: SuggestedProcess[] = [];
            
            if (lowerObjective.includes('recrutement') || lowerObjective.includes('recruitment')) {
                suggested.push({
                    title: "Processus de recrutement",
                    description: "Gestion complète du processus de recrutement depuis la publication de l'offre jusqu'à l'intégration",
                    reason: "Correspond à votre objectif d'amélioration du recrutement"
                });
                suggested.push({
                    title: "Processus de sélection des candidats",
                    description: "Évaluation et sélection des candidats selon des critères définis",
                    reason: "Complémentaire au processus de recrutement"
                });
            }
            
            if (lowerObjective.includes('commande') || lowerObjective.includes('order')) {
                suggested.push({
                    title: "Gestion des commandes",
                    description: "Traitement et suivi des commandes clients de la réception à la livraison",
                    reason: "Correspond à votre objectif d'optimisation des commandes"
                });
                suggested.push({
                    title: "Processus de facturation",
                    description: "Génération et suivi des factures clients",
                    reason: "Lié à la gestion des commandes"
                });
            }
            
            // Si aucun processus spécifique n'a été trouvé, suggérer des processus génériques
            if (suggested.length === 0) {
                suggested.push({
                    title: "Processus principal",
                    description: "Processus principal pour atteindre votre objectif",
                    reason: "Basé sur l'analyse de votre objectif"
                });
            }
            
            return suggested;
        } catch (error) {
            console.error('Error analyzing objective:', error);
            return [];
        }
    };

    async function uploadFileToAnalyze(interviewId: string, processId: string, fileToUpload: File | null) {
        try {
            if (!fileToUpload) {
                return;
            }
            const token = users.access_token;
            if (fileToUpload.type === "application/pdf") {
                const endpoint = `/file/analyze-pdf?interview_id=${interviewId}&process_id=${processId}`;
                const formData = new FormData();
                formData.append("file", fileToUpload);
                const data = await FamlaServices("api_host", endpoint, "POST", formData, token);

                if (data.status === 201) {
                    setFile(null);
                }
            } else {
                const endpoint = `/file/?interview_id=${interviewId}`;
                const formData = new FormData();
                formData.append("fileobject", fileToUpload);

                const data = await FamlaServices("api_host", endpoint, "POST", formData, token);

                if (data.status === 201) {
                    setFile(null);
                }
            }
        } catch (error) {

        }
    }


    const sendAnswer = async (
        e: React.MouseEvent<HTMLButtonElement>,
        answerId: string | undefined,
        answerA: string,
        answer_id: string,
        /** Fichier à envoyer dans ce tour (state `file` peut être obsolète juste après sélection). */
        attachedFile?: File | null,
        /** Clé stats explicite (Oui/Non, contexte IA, etc.) ; sinon envoi de message (chat). */
        statsKeyOverride?: string,
    ) => {
        // Lecture seule sur la contribution d'un autre utilisateur
        if (!state.autorisation) {
            return;
        }
        const eventKey = statsKeyOverride ?? UI_BUTTON_EVENTS.interview.chatSend;
        await trackUiButtonEventAsync(eventKey);
        setSpinner(true);
        const fileToUse = attachedFile !== undefined ? attachedFile : file;

        // Mode campagne : analyser l'objectif et suggérer des processus
        if (isCampaignMode && answerA.trim().length > 0) {
            // Ajouter la réponse de l'utilisateur au chat
            const userMessage: iInterviewContent = {
                _id: `user-${Date.now()}`,
                question_text: "",
                content: answerA,
                step: [0, 0],
                file: false,
                created_at: new Date().toISOString(),
                interview_id: "",
                invited: null,
                is_valid: true,
                thumbs: null,
                updated_at: null,
            };
            
            setState((prevState) => ({
                ...prevState,
                questionAndResponse: [...prevState.questionAndResponse, userMessage],
                answer: "",
            }));

            // Analyser l'objectif et obtenir les processus suggérés
            const processes = await analyzeObjectiveAndSuggestProcesses(answerA);
            setSuggestedProcesses(processes);

            // Ajouter une réponse de l'IA
            const aiResponse: iInterviewContent = {
                _id: `ai-${Date.now()}`,
                question_text: t('campaigns.objectiveAnalyzed') || "J'ai analysé votre objectif. Voici les processus que je suggère pour l'atteindre :",
                content: "",
                step: [0, 0],
                file: false,
                created_at: new Date().toISOString(),
                interview_id: "",
                invited: null,
                is_valid: true,
                thumbs: null,
                updated_at: null,
                suggestedProcesses: processes, // Stocker les processus suggérés dans la réponse
            };

            setState((prevState) => ({
                ...prevState,
                questionAndResponse: [...prevState.questionAndResponse, aiResponse],
            }));

            setSpinner(false);
            return;
        }

        if (processType === "HUMAN" && fileToUse && answerA.trim().length > 0) {
            setAlert({
                isActive: true,
                type: "warning",
                message: t("views.processInterview.oneActionAtTime")
            });
            return;
        }

        const updatedAnswers = [...state.questionAndResponse];
        const lastItemIndex = updatedAnswers.length - 1;
        if (lastItemIndex >= 0) {
            updatedAnswers[lastItemIndex] = {
                ...updatedAnswers[lastItemIndex],
                content: answerA,
            };
        }

        setState((prevState) => ({
            ...prevState,
            questionAndResponse: updatedAnswers,
            answer: "",
        }));

        // Rôle de la question 1.5 à laquelle on répond (pas un rôle refusé précédemment)
        const answeredInvite = updatedAnswers.find((q) => q._id === answer_id);
        if (answeredInvite?.step?.[0] === 1 && answeredInvite?.step?.[1] === 5) {
            const role = resolveInviteRoleFromAnswer(answeredInvite);
            if (role) setInvited(role);
        }

        const answerPayload = {
            content: answerA,
            answer_id: answer_id,
        };

        if (processType === "AI" && fileToUse) {
            await uploadFileToAnalyze(interviewwId ?? "", procesId, fileToUse);
        }
        const upLoadFileEndpoint = `/file/human/analyze-pdf?interview_id=${interviewwId}&process_id=${procesId}`
        const formData = new FormData();
        fileToUse && formData.append(processType === "HUMAN" ? 'file' : 'fileobject', fileToUse);

        const endPayload = processType !== "AI" && fileToUse ? formData : answerPayload

        let endpoint = "";

        /* In fact, it is answerid get in this function, is the interviewID of the currect interview */
        switch (processType) {
            case "HUMAN":
                endpoint = file ? upLoadFileEndpoint : `/answer/human/led/${answerId}`;
                break;
            case "IMAGE":
                endpoint = file ? `/file/image/swimlane?interview_id=${interviewwId}` : `/answer/image/led/${interviewwId}`;
                break;
            default:
                endpoint = `/answer/${answerId}`;
        }

        const methode = processType !== "AI" && fileToUse ? "POST" : "PUT"

        const data = await FamlaServices("api_host", endpoint, methode, endPayload, users.access_token);


        if (data.status === 200 || data.status === 201 || data.body.status_code === 200) {
            const response = data.body.data;
            const newResponses = processType !== "AI" && Array.isArray(response)
                ? response
                : [response];

            const updatedList = [...updatedAnswers, ...newResponses];

            setState((prevState) => ({
                ...prevState,
                questionAndResponse: updatedList,
                interviewId: prevState.interviewId,
                answer: "",
            }));

            if (fileToUse) {
                setFile(null);
            }
        } else if (data.status === 426) {
            setAlert({
                isActive: true,
                type: "warning",
                message: t("views.processInterview.requestLimit"),
            });
            setIsInputBlocked(true);
        }

        setSpinner(false);
        setThumbs({ ...thumbs, up: false, down: false });
    };

    // Expose « envoyer Oui » au parent (après succès d'invitation dans le modal).
    // Mise à jour à chaque render pour capturer le sendAnswer courant (state à jour).
    React.useEffect(() => {
        if (!inviteYesSenderRef) return;
        inviteYesSenderRef.current = async () => {
            const pending = pendingInviteYesRef.current;
            if (!pending) return;
            // Consommer le pending avant l'envoi pour que la fermeture du modal ne l'annule pas
            pendingInviteYesRef.current = null;
            const fakeEvent = {
                preventDefault: () => undefined,
                stopPropagation: () => undefined,
            } as React.MouseEvent<HTMLButtonElement>;
            await sendAnswer(
                fakeEvent,
                pending.interviewId,
                t('words.yes'),
                pending.answerId,
                undefined,
                UI_BUTTON_EVENTS.interview.chatReplyYes,
            );
            // Garder freeze jusqu'à hidden.bs.modal pour que le select reste sur le rôle invité
        };
    });

    React.useEffect(() => {
        return () => {
            if (inviteYesSenderRef) inviteYesSenderRef.current = null;
        };
    }, [inviteYesSenderRef]);

    const updateContent = async (
        answerId: string,
        content: string,
    ) => {
        if (!state.autorisation) return;
        try {

            setState((prevState) => {
                const updatedQuestions = prevState.questionAndResponse.map((question) =>
                    question._id === answerId
                        ? { ...question, content: content }
                        : question
                );
                return {
                    ...prevState,
                    questionAndResponse: updatedQuestions,
                };
            });

            const answerData = {
                content: content,
                answer_id: answerId,
            };

            const data = await FamlaServices("api_host", `/answer/content/update`, "PUT", answerData, users.access_token);

            if (data.status === 200) {
                // const newQuestionAndResponse = { ...data.body.data };
                // setState((prevState) => {
                //     const updatedQuestions = [...prevState.questionAndResponse];
                //     if (updatedQuestions.length > 0) {
                //         updatedQuestions[updatedQuestions.length - 1] = newQuestionAndResponse;
                //     }
                //     return {
                //         ...prevState,
                //         questionAndResponse: updatedQuestions,
                //         interviewId: prevState.interviewId,
                //         answer: "",
                //     };
                // });

                if (file) {
                    void uploadFileToAnalyze(interviewwId ?? "", procesId, file);
                }

            } else if (data.status === 426) {
                setAlert({
                    isActive: true,
                    type: 'warning',
                    message: t('views.processInterview.requestLimit'),
                });
                setIsInputBlocked(true)
            } else {
            }
        } catch (error) {
            console.error('Erreur de requête', error);
        } finally {
            setSpinner(false);
        }
    };


    const updateAnswerWithUpDown = async (upDown: string, answerId: string) => {
        if (!state.autorisation) return;
        if (upDown === 'up') {
            await trackUiButtonEventAsync(UI_BUTTON_EVENTS.interview.feedbackThumbUp);
        } else {
            await trackUiButtonEventAsync(UI_BUTTON_EVENTS.interview.feedbackDownComment);
        }
        setThumbs(prevThumbs => ({ ...prevThumbs, submit: true, up: upDown === 'up', down: upDown === 'down' }));

        const form = {
            up: upDown === 'up',
            comment: thumbs.comment
        };

        try {
            const data = await FamlaServices("api_host", `/answer/thumbs/${answerId}`, "PUT", form, users.access_token);

            if (data.status === 200) {
                setThumbs({
                    up: upDown === 'up',
                    down: upDown === 'down',
                    comment: "",
                    submit: false,
                });
            } else {
                setThumbs(prevThumbs => ({ ...prevThumbs, submit: false }));
            }
        } catch (error) {
            setThumbs(prevThumbs => ({ ...prevThumbs, submit: false }));
        }
    }

    const shouldDisplayActionButtons = (question: iInterviewContent, index: number, totalQuestions: number,): boolean => {
        const isFinalQuestion = index === totalQuestions - 1;

        // Add null/existing checks for question.step
        if (!question.step || !Array.isArray(question.step) || question.step.length < 2) {
            return false;
        }

        const isSpecificStepMatchHumanProcess =
            (question.step[0] === 4 && question.step[1] === 3) ||
            (question.step[0] === 4 && question.step[1] === 5)

        const isSpecificStepMatch =
            (question.step[0] === 1 && question.step[1] === 4 && question.question_text !== referenceQuestion) ||
            (question.step[0] === 3 && question.step[1] === 5 && question.question_text !== referenceQuestion) ||
            question.question_text === referenceQuestion1;

        const isAlternateStepMatch = question.step[0] === 1 && question.step[1] === 3;

        const isSpecificStepMatchImageProcessType = (question.step[0] === 5 && question.step[1] === 3) || (question.step[0] === 5 && question.step[1] === 5)
        return (isSpecificStepMatch || isAlternateStepMatch || isSpecificStepMatchHumanProcess || isSpecificStepMatchImageProcessType) && isFinalQuestion;
    };

    const shouldHideTextarea = (): boolean => {
        if (state.questionAndResponse.length === 0) return false;
        const lastQuestion = state.questionAndResponse[state.questionAndResponse.length - 1];
        if (shouldDisplayActionButtons(lastQuestion, state.questionAndResponse.length - 1, state.questionAndResponse.length)) {
            return true;
        }
        if (ownerInviteOneFiveActionIndex >= 0) return true;
        return false;
    };



    const canUploadFileAtStep = (
        question: iInterviewContent,
        index: number,
        processType: typeProcess
    ): boolean => {
        /*
        // Vérifications de sécurité (utilisé pour l'ajout de fichiers lors de la conversation dans la 'discover process as')
        if (!question.step || !Array.isArray(question.step) || question.step.length < 2) {
            return false;
        }
        */

        const stepMap: Record<typeProcess, [number, number]> = {
            HUMAN: [4, 1],
            IMAGE: [5, 1],
            AI: [-1, -1],
            MANUAL: [-1, -1],
        };

        const expectedStep = stepMap[processType];
        const hasFileInThisStep =
            expectedStep &&
            question.step[0] === expectedStep[0] &&
            question.step[1] === expectedStep[1];

        return hasFileInThisStep;
    };

    function setThumbsUpDown(upDown: string) {
        if (upDown === 'down') {
            void trackUiButtonEventAsync(UI_BUTTON_EVENTS.interview.feedbackThumbDown);
        }
        setThumbs(prevThumbs => ({
            ...prevThumbs,
            up: upDown === 'up',
            down: upDown === 'down'
        }));
    }

    const handleChange = (event: any) => {
        const { type, name, value, checked } = event.target;
        let fieldValue = type === 'checkbox' ? checked : value;

        if (type === 'number') {
            fieldValue = Number(fieldValue);
        }
        if (name === 'area') {
            setState({ ...state, answer: fieldValue })
        }
        if (name === 'area1') {
            setThumbs({ ...thumbs, comment: fieldValue })
        }
        if (type === 'number') {
            fieldValue = Number(fieldValue);
        }
        if (name === 'email') {
            setState((prev) => ({ ...prev, email: fieldValue }))
        } else if (name === 'role') {
            setState({ ...state, role: fieldValue })
        }
    };

    function tag() {
        // En mode campagne, toujours permettre l'input
        if (isCampaignMode) {
            return true;
        }
        const lastQuestion = state.questionAndResponse[state.questionAndResponse.length - 1]?.question_text;
        if (!lastQuestion) return true;
        const endInterviewRegex = END_INTERVIEW_REGEX;
        return !endInterviewRegex.test(lastQuestion);
    }

    const updateAnswer = (newAnswer: string) => {
        setState((prevState) => ({
            ...prevState,
            answer: newAnswer,
        }));
    };

    const handleFileSelect = (selectedFile: File) => {
        setFile(selectedFile);
    };

    const handleUploadStateChange = (uploading: boolean) => {
        setIsFileUploading(uploading);
    };

    const handleFilePaste = (pastedFile: File) => {
        // Validate file type and size based on processType
        const typeConfig: Record<typeProcess, { types: string[]; maxSize: number }> = {
            AI: {
                types: ['application/pdf', 'image/png', 'image/jpeg', 'image/gif', 'image/webp'],
                maxSize: 5 * 1024 * 1024,
            },
            HUMAN: {
                types: [
                    'application/pdf',
                    'text/plain',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                ],
                maxSize: 10 * 1024 * 1024,
            },
            IMAGE: {
                types: ['application/pdf', 'image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'],
                maxSize: 5 * 1024 * 1024,
            },
            MANUAL: {
                types: [],
                maxSize: 0,
            },
        };

        const currentProcess = (processType ?? 'HUMAN') as typeProcess;
        const config = typeConfig[currentProcess];

        // Validate file
        if (!config.types.includes(pastedFile.type)) {
            setAlert({
                isActive: true,
                type: 'warning',
                message: t('views.processInterview.validFilleAi')
            });
            setTimeout(() => setAlert({ isActive: false, type: '', message: '' }), 3000);
            return;
        }

        if (pastedFile.size > config.maxSize) {
            setAlert({
                isActive: true,
                type: 'warning',
                message: t('views.processInterview.validFilleAi')
            });
            setTimeout(() => setAlert({ isActive: false, type: '', message: '' }), 3000);
            return;
        }

        // File is valid, set it
        setFile(pastedFile);
        setAlert({
            isActive: true,
            type: 'success',
            message: t('views.processInterview.fileUploaded')
        });
        setTimeout(() => setAlert({ isActive: false, type: '', message: '' }), 3000);
    };

    const handleSynthesize = async (answerId: string) => {
        try {

            if (audioRef.current) {
                // Si l'audio est déjà en cours de lecture et que l'utilisateur veut l'arrêter
                if (isPlaying && !audioRef.current.paused) {
                    audioRef.current.pause(); // Mettre l'audio en pause
                    setIsPlaying(false);
                    return;
                }

                // Si l'audio est en pause, le reprendre
                if (audioRef.current.paused) {
                    audioRef.current.play().catch(() => {
                        console.error("Failed to resume audio");
                    });
                    setIsPlaying(true);
                    return;
                }
            }


            setIsPlaying(true);
            setIsAudioFinished(false);

            // Récupérer le nouvel audio si nécessaire
            const response = await FamlaServices("api_host", `/audio/${answerId}`, "GET", "", users.access_token);

            if (response.status === 200) {
                const audioSrc = `${BASE_URL_AUDIO.url}${response.body.data}`;

                // Si un audio existant est déjà en lecture, on ne crée pas un nouveau fichier audio
                if (!audioRef.current || audioRef.current.src !== audioSrc) {
                    const audio = new Audio(audioSrc);
                    audioRef.current = audio;

                    // Lecture du nouvel audio
                    audio.play().catch(() => {
                        console.error("Failed to play audio");
                    });

                    // Gérer la fin de l'audio
                    audio.onended = () => {
                        setIsPlaying(false);
                        setIsAudioFinished(true);
                    };
                }
            }
        } catch (error) {
            setIsPlaying(false);
            setIsAudioFinished(false);
        }
    };

    const hasChecklistRail = shouldShowMappingChecklist && checklistItems.length > 0;
    const useDiscoverLayout = shouldShowMappingChecklist;

    const updateScrollDateLabel = React.useCallback(() => {
        const container = refchat.current;
        if (!container || !useModernLayout) return;
        const nodes = container.querySelectorAll('[data-msg-timestamp]');
        const containerRect = container.getBoundingClientRect();
        const threshold = containerRect.top + 40;
        let chosen = '';
        for (const node of nodes) {
            const el = node as HTMLElement;
            if (el.getBoundingClientRect().top <= threshold) {
                chosen = el.getAttribute('data-msg-timestamp') || '';
            }
        }
        if (!chosen && state.questionAndResponse[0]?.created_at) {
            chosen = state.questionAndResponse[0].created_at;
        }
        setStickyDateLabel(chosen ? formatInterviewScrollHeader(chosen) : '');
    }, [useModernLayout, state.questionAndResponse]);

    const firstInterviewTimestamp = state.questionAndResponse[0]?.created_at;
    const scrollHeaderDisplay =
        stickyDateLabel ||
        (firstInterviewTimestamp ? formatInterviewScrollHeader(firstInterviewTimestamp) : '');

    React.useLayoutEffect(() => {
        if (!useModernLayout) {
            setStickyDateLabel('');
            return;
        }
        requestAnimationFrame(() => updateScrollDateLabel());
    }, [useModernLayout, state.questionAndResponse, updateScrollDateLabel]);

    React.useEffect(() => {
        const el = refchat.current;
        if (!useModernLayout || !el) return;
        updateScrollDateLabel();
        el.addEventListener('scroll', updateScrollDateLabel, { passive: true });
        return () => el.removeEventListener('scroll', updateScrollDateLabel);
    }, [useModernLayout, updateScrollDateLabel]);

    if (!isCampaignMode && !isLayoutReady) {
        return (
            <div className="w-100 d-flex justify-content-center align-items-center custom-vh">
                <Spiner className="spinner-border-sm" />
            </div>
        );
    }

    const pendingQuestionTextForVoice =
        state.questionAndResponse.length > 0
            ? state.questionAndResponse[state.questionAndResponse.length - 1]?.question_text
            : undefined;

    const showVoiceRealtime =
        processType === "AI" &&
        !isCampaignMode &&
        Boolean(interviewwId) &&
        !endOfInterview &&
        !isInputBlocked &&
        Boolean(state.autorisation);

    const renderAiActions = (question: iInterviewContent, index: number) => {
        if (!state.autorisation) return null;
        const isLast = index === state.questionAndResponse.length - 1;
        if (!isLast) return null;

        const showFeedback = question.question_text !== endReply0 && question.question_text !== other && question.question_text !== endReply;

        return (
            <>
                {showFeedback && (
                    <button
                        className={`msg-btn ${thumbs.up ? 'liked' : ''}`}
                        title="Like"
                        onClick={() => updateAnswerWithUpDown('up', question._id)}
                    >
                        <svg viewBox="0 0 16 16" fill="none">
                            <path d="M5 7V13H3C2.4 13 2 12.6 2 12V8C2 7.4 2.4 7 3 7H5ZM5 7L7 2C7.8 2 9 2.4 9 4V6H12.5C13.1 6 13.5 6.5 13.4 7.1L12.4 12.1C12.3 12.6 11.9 13 11.4 13H5V7Z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
                        </svg>
                    </button>
                )}
                {showFeedback && (
                    <button
                        className={`msg-btn danger ${thumbs.down ? 'selected' : ''}`}
                        title="Dislike"
                        onClick={() => setThumbsUpDown('down')}
                    >
                        <svg viewBox="0 0 16 16" fill="none">
                            <path d="M11 9V3H13C13.6 3 14 3.4 14 4V8C14 8.6 13.6 9 13 9H11ZM11 9L9 14C8.2 14 7 13.6 7 12V10H3.5C2.9 10 2.5 9.5 2.6 8.9L3.6 3.9C3.7 3.4 4.1 3 4.6 3H11V9Z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
                        </svg>
                    </button>
                )}
                {/*
                <button
                    className="msg-btn"
                    title="Listen"
                    onClick={() => handleSynthesize(question._id)}
                >
                    <svg viewBox="0 0 16 16" fill="none">
                        <rect x="5" y="1" width="6" height="9" rx="3" stroke="currentColor" strokeWidth="1.2"/>
                        <path d="M3 8C3 10.8 5.2 13 8 13C10.8 13 13 10.8 13 8" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
                        <path d="M8 13V15" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
                    </svg>
                </button>
                */}
                {showVoiceRealtime && !voiceSessionActive && (
                    <button
                        type="button"
                        className="msg-btn"
                        title={t("views.processInterview.voiceConversationStart", {
                            defaultValue: "Voice conversation",
                        })}
                        disabled={spinner}
                        onClick={async () => {
                            await trackUiButtonEventAsync(UI_BUTTON_EVENTS.interview.voiceStart);
                            void voiceRealtimeBarRef.current?.start();
                        }}
                    >
                        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                            <rect x="5" y="1" width="6" height="9" rx="3" stroke="currentColor" strokeWidth="1.2" />
                            <path
                                d="M3 8C3 10.8 5.2 13 8 13C10.8 13 13 10.8 13 8"
                                stroke="currentColor"
                                strokeWidth="1.2"
                                strokeLinecap="round"
                            />
                            <path d="M8 13V15" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                        </svg>
                    </button>
                )}
            </>
        );
    };

    const chatThreadClass = useModernLayout ? 'thread' : `overflow-auto custom-vh pb-5 px-0 ${hasChecklistRail ? "px-md-2" : "px-md-3"}`;
    const shellClass = useDiscoverLayout ? `interview-chat-shell position-relative ${hasChecklistRail ? "with-checklist" : ""}` : "w-75 w-sm-100 m-auto position-relative";
    const mainColumnClass = useDiscoverLayout ? `interview-main-column position-relative ${hasChecklistRail ? "with-checklist" : ""}` : "position-relative";

    const threadContent = (
        <div
            className={chatThreadClass}
            ref={refchat}
        >
                    {useModernLayout && !state.isLoading && scrollHeaderDisplay && (
                        <div className="interview-scroll-date-sticky" aria-live="polite">
                            {scrollHeaderDisplay}
                        </div>
                    )}
                    {isWhatsAppChannel && (
                        <div className="alert alert-info py-2 px-3 mb-3" role="status">
                            {t('navigation.whatsappSupervisionHint')}
                        </div>
                    )}
                    {state.isLoading ?
                        <Spiner className="d-flex justify-content-center spinner-border-sm " />
                        :
                        <>
                            {isCampaignMode && state.questionAndResponse.length === 0 && (
                                <Question
                                    index={0}
                                    currentIndex={currentIndex}
                                    questionText={t('campaigns.welcomeMessage')}
                                    questionAndResponseLength={1}
                                    setCurrentIndex={setCurrentIndex}
                                    useModernLayout={useModernLayout}
                                    senderName={getTenantName()}
                                />
                            )}

                            {state.questionAndResponse.map((question: iInterviewContent, index: number) => (
                                <div
                                    key={question._id}
                                    data-msg-timestamp={question.created_at || ''}
                                >
                                    <Question
                                        key={index}
                                        index={index}
                                        currentIndex={currentIndex}
                                        questionText={question.question_text}
                                        questionAndResponseLength={state.questionAndResponse.length}
                                        setCurrentIndex={setCurrentIndex}
                                        useModernLayout={useModernLayout}
                                        senderName={getTenantName()}
                                        timestamp={question.created_at}
                                        actions={useModernLayout ? renderAiActions(question, index) : undefined}
                                    />

                                    {state.autorisation && shouldDisplayActionButtons(question, index, state.questionAndResponse.length) &&
                                        <ButtonGroup
                                            buttons={[
                                                {
                                                    text: t('words.yes'),
                                                    onClick: (e) =>
                                                        void sendAnswer(
                                                            e,
                                                            interviewwId,
                                                            t('words.yes'),
                                                            question._id,
                                                            undefined,
                                                            UI_BUTTON_EVENTS.interview.chatReplyYes
                                                        )
                                                },
                                                {
                                                    text: t('words.no'),
                                                    onClick: (e) =>
                                                        void sendAnswer(
                                                            e,
                                                            interviewwId,
                                                            t('words.no'),
                                                            question._id,
                                                            undefined,
                                                            UI_BUTTON_EVENTS.interview.chatReplyNo
                                                        )
                                                }
                                            ]}
                                            className="ps-3 mt-3"
                                            ariaLabel="Basic radio toggle button group"
                                        />
                                    }
                                    {state.autorisation && (ownerInviteOneFiveActionIndex === index) &&
                                        <ButtonGroup
                                            buttons={[
                                                {
                                                    text: t('words.yes'),
                                                    onClick: () => {
                                                        // Ouvrir le modal sur CE rôle ; n'envoyer « Oui » qu'après invite réussie
                                                        // (sinon l'API passe à la question du rôle suivant pendant que le modal est ouvert).
                                                        const role = resolveInviteRoleFromAnswer(question);
                                                        freezeInviteRoleRef.current = true;
                                                        pendingInviteYesRef.current = {
                                                            interviewId: interviewwId,
                                                            answerId: question._id,
                                                        };
                                                        flushSync(() => {
                                                            setInvited(role || undefined);
                                                        });
                                                        const el = document.getElementById('inviteUser');
                                                        const bootstrap = (window as any).bootstrap;
                                                        if (el && bootstrap?.Modal) {
                                                            bootstrap.Modal.getOrCreateInstance(el).show();
                                                        }
                                                    },
                                                },
                                                {
                                                    text: t('words.no'),
                                                    onClick: (e) =>
                                                        void sendAnswer(
                                                            e,
                                                            interviewwId,
                                                            t('words.no'),
                                                            question._id,
                                                            undefined,
                                                            UI_BUTTON_EVENTS.interview.chatReplyNo
                                                        )
                                                }
                                            ]}
                                            className="ps-3 mt-3"
                                            ariaLabel="Basic radio toggle button group"
                                        />

                                    }

                                    {(thumbs.down && index === state.questionAndResponse.length - 1) && (
                                        <TextAreaForm
                                            name="area1"
                                            sendButton={thumbs.comment.trim().length > 0}
                                            label=""
                                            rows={1}
                                            classNameArea={useModernLayout ? 'input-field' : "w-100 bg-transparent text-light text-bg-dark py-2 px-3 rounded-2 pe-5 border-0 mb-2"}
                                            classNameContainer={useModernLayout ? 'input-inner' : "custom_width_area message-box rounded-4 mt-3"}
                                            placeholder={t('views.processInterview.comment') + '...'}
                                            onChange={(e) => handleChange(e)}
                                            value={thumbs.comment}
                                            interviewId={state.interviewId}
                                            sendAnswer={() => updateAnswerWithUpDown("down", question._id)}
                                            spinner={thumbs.submit}
                                            maxRows={4}
                                            minRows={3}
                                            button={true}
                                            readOnly={false}
                                            updateAnswer={() => { }}
                                            recognition={false}
                                            useModernLayout={useModernLayout}
                                        />
                                    )}

                                    {(((question.step[0] === 1 &&
                                        question.step[1] === 2) &&
                                        state.questionAndResponse.length < 3 &&
                                        processType !== 'AI') ||
                                        (canUploadFileAtStep(question, index, processType) &&
                                            index === state.questionAndResponse.length - 1)) && (
                                            <FileUpload
                                                onFileSelect={handleFileSelect}
                                                processType={processType}
                                                onUploadStateChange={handleUploadStateChange}
                                            />
                                        )}

                                    {(question.content?.length > 0 || question.content !== null) &&
                                        <ContentQuestion
                                            fullname={collaborator.fullname}
                                            questionData={question}
                                            lastAnsweredIndex={lastAnsweredIndex}
                                            file={file}
                                            fileIn={question.file}
                                            index={index}
                                            onFileSelect={handleFileSelect}
                                            updateContent={updateContent}
                                            processType={processType}
                                            isOwner={isProcessOwner}
                                            hasStakeholders={invitedCollaborations.length > 0}
                                            processTitle={interviews?.collaboration?.process?.title}
                                            isCompleted={isInputBlocked}
                                            canWrite={Boolean(state.autorisation)}
                                            onDeleteSuccess={refreshAfterMessageDelete}
                                            ownerAsStakeholder={
                                                interviews?.for_owner==false &&
                                                interviews.collaboration.user._id == interviews.collaboration.process.owner._id
                                            }
                                            useModernLayout={useModernLayout}
                                        />
                                    }

                                    {question.suggestedProcesses && question.suggestedProcesses.length > 0 && (
                                        <div className="mt-3">
                                            <SuggestedProcessesCard
                                                processes={question.suggestedProcesses}
                                            />
                                        </div>
                                    )}

                                    {(alert.isActive && index === state.questionAndResponse.length - 1) &&
                                        <Alert
                                            type={alert.type}
                                            msg={alert.message}
                                            clasName='mt-3'
                                            zIndex={2000}
                                            key={alert.type}
                                        />
                                    }

                                </div>
                            ))}

                            {spinner && (
                                <div className={useModernLayout ? "turn ai-turn" : "mt-4"}>
                                    {useModernLayout ? (
                                        <div className="t-avatar t-ai">{getTenantInitial()}</div>
                                    ) : (
                                        <img src={Images.logov1} alt="Logo" className='imgFluid' />
                                    )}
                                    <div className={useModernLayout ? "t-body" : "ps-3 mt-1"}>
                                        {useModernLayout && (
                                            <div className="t-sender s-ai">famla</div>
                                        )}
                                        <TypingIndicator />
                                    </div>
                                </div>
                            )}
                        </>
                    }
        </div>
    );

    const composerInner = isWhatsAppChannel ? null : (
        <>
            {showVoiceRealtime && (
                <VoiceRealtimeBar
                    ref={voiceRealtimeBarRef}
                    interviewId={interviewwId}
                    accessToken={users.access_token}
                    disabled={spinner}
                    t={t}
                    pendingQuestionText={pendingQuestionTextForVoice}
                    textDraft={state.answer}
                    onVoiceSessionChange={setVoiceSessionActive}
                    onPersistSuccess={getMyInterviewByProcess}
                />
            )}
            <Area
                state={state}
                handleChange={handleChange}
                sendAnswer={sendAnswer}
                interviewwId={interviewwId}
                idLastAnwser={idLastAnwser}
                tag={tag}
                t={t}
                spinner={spinner}
                isInputBlocked={isInputBlocked}
                swimlanes={swimlanes}
                role={role}
                isFileUploading={isFileUploading}
                time={time}
                updateAnswer={updateAnswer}
                recognition={true}
                file={file}
                isAudioFinished={isAudioFinished}
                processType={processType}
                isCampaignMode={isCampaignMode}
                onFilePaste={handleFilePaste}
                shouldHideTextarea={shouldHideTextarea()}
                currentQuestionStep={state.questionAndResponse.length > 0 ? state.questionAndResponse[state.questionAndResponse.length - 1]?.step : undefined}
                useModernLayout={useModernLayout}
                voiceLocksTextInput={voiceSessionActive}
                onVoiceConversationClick={
                    showVoiceRealtime && !voiceSessionActive
                        ? async () => {
                              await trackUiButtonEventAsync(UI_BUTTON_EVENTS.interview.voiceStart);
                              void voiceRealtimeBarRef.current?.start();
                          }
                        : undefined
                }
            />
        </>
    );

    const inputArea = composerInner;

    if (useModernLayout) {
        return (
            <>
                {threadContent}
                <div className="interview-composer-dock">{composerInner}</div>
            </>
        );
    }

    return (
        <>
        <div className={shellClass}>
            <div className={mainColumnClass}>
                {threadContent}

                <div className="w-100 custom_parent_area">
                    {inputArea}
                </div>
            </div>

            {hasChecklistRail && (
                <aside className="interview-checklist-rail" style={{ opacity: isProgressLoading ? 0.92 : 1 }}>
                    <div className="interview-checklist-panel interview-rail-section">
                        <MappingProgressChecklist items={checklistItems} progressPercent={ownerProgressPercent} />
                    </div>

                    <div className="interview-checklist-panel interview-rail-section mt-3">
                        <h4 className="text-gradient fs-6 mb-2 text-nowrap">
                            {t('views.processInterview.quickActionsTitle') || 'Quick Actions'}
                        </h4>
                        <div className="d-grid gap-2">
                            <button
                                className="text-decoration-none text-light fs-6 bg-dark border-0 rounded-4 mb-2 px-1 w-100"
                                style={{ textAlign: 'left' }}
                                onClick={async () => {
                                    await trackUiButtonEventAsync(
                                        UI_BUTTON_EVENTS.interview.railNewDiscovery
                                    );
                                    window.location.href = getProcessCreatePath(processType);
                                }}>
                                <div className="py-1 px-1 border-0 text-gradient d-flex align-items-center gap-2">
                                    <span><i className="fa-solid fa-plus"></i></span>
                                    <span className="ms-1 text-nowrap" title={t('views.processInterview.startNewDiscovery') || 'Start new discovery interview'}>
                                        {t('views.processInterview.startNewDiscovery') || 'Start new discovery interview'}
                                    </span>
                                </div>
                            </button>

                            <button
                                className="text-decoration-none text-light fs-6 bg-dark border-0 rounded-4 mb-2 px-1 w-100"
                                style={{ textAlign: 'left' }}
                                onClick={async () => {
                                    await trackUiButtonEventAsync(
                                        UI_BUTTON_EVENTS.interview.railProcessLibrary
                                    );
                                    window.location.href = Routes.PROCESSLIBRARY;
                                }}>
                                <div className="py-1 px-1 border-0 text-gradient d-flex align-items-center gap-2">
                                    <span><i className="fa-regular fa-folder-open"></i></span>
                                    <span className="ms-1 text-nowrap" title={t('views.processInterview.openProcessLibrary') || 'Open Process Library'}>
                                        {t('views.processInterview.openProcessLibrary') || 'Open Process Library'}
                                    </span>
                                </div>
                            </button>

                            <button
                                className="text-decoration-none text-light fs-6 bg-dark border-0 rounded-4 mb-2 px-1 w-100"
                                style={{ textAlign: 'left' }}
                                onClick={async () => {
                                    await trackUiButtonEventAsync(
                                        UI_BUTTON_EVENTS.interview.railExportTranscript
                                    );
                                    try {
                                        if (!procesId) return;
                                        const response = await FamlaServices("api_host", `/file/export-pdf/?process_id=${procesId}`, "GET", "", users.access_token);
                                        if (response.contentType && response.contentType.includes("application/pdf")) {
                                            const blob = response.body;
                                            const link = document.createElement('a');
                                            link.href = window.URL.createObjectURL(blob);
                                            link.download = `process_${procesId}.pdf`;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }
                                    } catch (e) {
                                        // silent
                                    }
                                }}>
                                <div className="py-1 px-1 border-0 text-gradient d-flex align-items-center gap-2">
                                    <span><i className="fa-solid fa-download"></i></span>
                                    <span className="ms-1 text-nowrap" title={t('views.processInterview.exportTranscript') || 'Export Transcript'}>
                                        {t('views.processInterview.exportTranscript') || 'Export Transcript'}
                                    </span>
                                </div>
                            </button>

                            <button
                                className="text-decoration-none text-light fs-6 bg-dark border-0 rounded-4 mb-2 px-1 w-100"
                                style={{ textAlign: 'left' }}
                                onClick={async () => {
                                    await trackUiButtonEventAsync(
                                        UI_BUTTON_EVENTS.interview.railShare
                                    );
                                    const shareModalEl = document.querySelector<HTMLElement>('[id^="shareModal"]');
                                    if (shareModalEl && shareModalEl.id) {
                                        const temp = document.createElement('button');
                                        temp.setAttribute('data-bs-target', `#${shareModalEl.id}`);
                                        temp.setAttribute('data-bs-toggle', 'modal');
                                        document.body.appendChild(temp);
                                        temp.click();
                                        setTimeout(() => document.body.removeChild(temp), 0);
                                        return;
                                    }
                                    const temp = document.createElement('button');
                                    temp.setAttribute('data-bs-target', '#inviteUser');
                                    temp.setAttribute('data-bs-toggle', 'modal');
                                    document.body.appendChild(temp);
                                    temp.click();
                                    setTimeout(() => document.body.removeChild(temp), 0);
                                }}>
                                <div className="py-1 px-1 border-0 text-gradient d-flex align-items-center gap-2">
                                    <span><i className="fa-solid fa-share-nodes"></i></span>
                                    <span className="ms-1 text-nowrap" title={t('views.processInterview.share') || 'Share'}>
                                        {t('views.processInterview.share') || 'Share'}
                                    </span>
                                </div>
                            </button>
                        </div>
                    </div>
                </aside>
            )}
        </div >
        <OutlookPromoModal trigger="first_interview" enabled={isInputBlocked} />
        </>
    )
}

export default ChatBot